import { apiClient } from "@copro/api";
import { useQuery } from "@tanstack/react-query";
import { _3_DAYS } from "../../../constants/durations";
import { keys } from "./keys";
import { fetchContractDocumentIds } from "../../documents/api/contractDocuments";

async function fetchProviderDocumentsCount(providerId: string): Promise<number> {
  // Contract files also carry this provider_id but are counted as contracts,
  // so exclude them here to match ProviderDocumentsList.
  const contractDocumentIds = await fetchContractDocumentIds(providerId);

  let query = apiClient
    .from('documents')
    .select('*', { count: 'exact', head: true })
    .eq('provider_id', providerId);

  if (contractDocumentIds.length > 0) {
    query = query.not('id', 'in', `(${contractDocumentIds.join(',')})`);
  }

  const { count, error } = await query;

  if (error) {
    throw error;
  }

  return count ?? 0;
}

export default function useGetProviderDocumentsCount(providerId: string | undefined) {
  return useQuery({
    queryKey: keys.getProviderDocumentsCount(providerId ?? ''),
    queryFn: () => fetchProviderDocumentsCount(providerId!),
    enabled: !!providerId,
    staleTime: _3_DAYS,
  });
}
